import Button from "@/components/Button/Button"
import {
  useMarkFreeMaterialAsDoneMutation,
  useRemoveFreeMaterialAsDoneMutation,
} from "@/queries/mutations/freeMaterialsMutations"
import {
  useFreeMaterialData,
  useStudentFreeMaterialEnrollments,
} from "@/queries/queries/freeMaterialsQueries"
import type { FreeMaterial } from "@/types/freeMaterialsTypes"
import { getEmbedUrl } from "@/utils/helpers"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router"

export default function FreeMaterialDetailsPreview() {
  const { courseId, subjectId, materialId } = useParams()

  const { t } = useTranslation()

  const freeMaterialsQuery = useFreeMaterialData()

  const material = freeMaterialsQuery.data?.data
    .find((course) => course.id === Number(courseId))
    ?.subjects?.find((subject) => subject.id === Number(subjectId))
    ?.free_materials?.find((material) => material.id === Number(materialId))

  if (!material) return null

  const embed = getEmbedUrl(material?.link)

  const studentFreeMaterialEnrollmentQuery = useStudentFreeMaterialEnrollments()
  const isStudentEnrolled = studentFreeMaterialEnrollmentQuery.data?.some(
    (enrollment) => enrollment.free_material_course_id === Number(courseId)
  )

  return (
    <div>
      {embed ? (
        <div className="d-flex flex-column gap-0">
          {isStudentEnrolled && (
            <div className="d-flex justify-content-end my-2 w-100">
              <MarkDoneInput material={material} />
            </div>
          )}
          <div className="ratio ratio-16x9">
            <iframe
              src={embed.url}
              title={embed?.type === "direct" ? "Article" : "Video Player"}
              allow="autoplay"
              allowFullScreen
              style={{ border: 0 }}
            />
          </div>
        </div>
      ) : (
        <p className="text-danger">
          {t("additionalMaterialsPreview.errors.invalid")}
        </p>
      )}
    </div>
  )
}

function MarkDoneInput({ material }: { material?: FreeMaterial }) {
  const { t } = useTranslation()

  const markFreeMaterialAsDoneMutation = useMarkFreeMaterialAsDoneMutation()
  const removeFreeMaterialAsDoneMutation = useRemoveFreeMaterialAsDoneMutation()

  if (!material) return null

  return (
    <Button
      className="fs-6 btn btn-warning"
      disabled={
        markFreeMaterialAsDoneMutation.isPending ||
        removeFreeMaterialAsDoneMutation.isPending
      }
      onClick={() => {
        if (material?.progress) {
          removeFreeMaterialAsDoneMutation.mutate(material)
        } else {
          markFreeMaterialAsDoneMutation.mutate({
            free_material_id: Number(material.id),
          })
        }
      }}
    >
      {material?.progress
        ? t("freeMaterialsPage.markNotDone")
        : t("freeMaterialsPage.markDone")}
    </Button>
  )
}
